import React from 'react';
import {toJS} from 'mobx';
import {observer} from 'mobx-react';

import {DatePicker, Row, Col, Input, Select, Radio, AutoComplete, Button} from 'antd';
import {exportFile} from '@src/Utils';
import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';

import moment from 'moment';

import MySearchComponent from '@ViewsDashboard/Common/MySearchComponent';

import GoToPage from '@common/GoToPage';

import store, {
  pagination_store,
  filter_store,
  WalletItemStore
} from '@store/Statistic/WalletHistory/WalletHistoryStore';
import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";

const { RangePicker } = DatePicker;

@observer
class WalletHistoryFilterForm extends React.Component {
  render() {

    let numberStyle = {
      fontSize: '22px',
      fontWeight: '700',
      marginLeft: '30px',
      float: 'right'
    };
    let tipStyle = {
      marginLeft: '10px',
      float: 'right'
    };

    let typeDefault = WalletItemStore.Type_Recharge;
    let tipTitle = '总充值';
    if (store.currentType == WalletItemStore.Type_Cash) {
      tipTitle = '总提现';
      typeDefault = WalletItemStore.Type_Cash;
    }

    return (
      <Row type="flex" justify="end" style={{flex: 1}}>
        <Col
          style={{
            lineHeight: '35px',
            marginLeft: '15px',
          }}>
          <MySearchComponent
            defaultValue={{
              agent:filter_store.agent?filter_store.agent:'',
              typeMode:CustomerTypeSelect.TYPE_MODE_AGENT,
              type:CustomerTypeSelect.getTypeName(CustomerTypeSelect.TYPE_MODE_AGENT,filter_store.proxy_type),
              search:filter_store.search?filter_store.search:'',
              date:filter_store.start_time != undefined?[filter_store.start_time,filter_store.end_time]:[]
            }}
            onClick={(values)=> {

              let agent = values.agent;

              if (agent == '')
              {
                agent = undefined
              }

              let search = values.search;

              if (search == '')
              {
                search = undefined;
              }

              let filter = {
                type:this.props.Types,
                agent:agent,
                proxy_type:2,
                search:search,
                type_time:values.type_time,
              }

              store.reloadDatas(this.props.Types,filter);

            }}
          />
        </Col>
        <Col
          style={{
            lineHeight: '35px',
            marginLeft: '15px',
            flex: 1
          }}>
          <span style={tipStyle}>{tipTitle}</span>
          <span style={numberStyle}>{Number(store.new_money).toFixed(2)}</span>
        </Col>
        {/*<Col style={{*/}
        {/*lineHeight: '32px'*/}
        {/*}}>*/}
        {/*<span style={numberStyle}>{Number(store.new_cash).toFixed(2)}</span>*/}
        {/*<span style={tipStyle}>今日提现</span>*/}
        {/*</Col>*/}
      </Row>
    )
  }
}


export default WalletHistoryFilterForm;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/WalletHistory/WalletHistoryFilterForm.jsx